import { connect } from 'react-redux';
import { getReviewsCount } from 'src/store/reviews/selectors';
import { getHotelRoulette } from 'src/routes/Hotel/store/hotel';
import { scrollToSectionAction } from '../../store/actions/view';
import { getSearcherFetching } from '../../store/selectors/searcher';
import { getHotelExperiences } from '../../store/selectors/experiences';
import { getDefaultPrice } from '../../store/selectors/common';
import TopMenu from './TopMenu';
import { getMenuItems } from './MenuItems';

const mapStateToProps = (state) => {
  const reviewCount = getReviewsCount(state);
  const isRoulette = getHotelRoulette(state);
  const hotelExperiences = getHotelExperiences(state);
  const hasExpiriences = hotelExperiences && hotelExperiences.length;

  return {
    minPrice: getDefaultPrice(state),
    fetching: getSearcherFetching(state),
    menuItems: getMenuItems(isRoulette, reviewCount, hasExpiriences),
  };
};

const mapDispatchToProps = {
  scrollToSection: scrollToSectionAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopMenu);
